import axios from 'axios';

const BASE_URL = '/app/assignOwnerFunnel';

export const loadInitialConfig = async () => {
    const {
        data: {
            userMap, roundRobinMap,
        },
    } = await axios.get(`${BASE_URL}/async/edit`);

    return { userMap, roundRobinMap };
};
